// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"05702864","513":"bbdad2f0","703":"a964be99","787":"98ac1120"}[chunkId] + ".chunk.js";
};